import { render, staticRenderFns } from "./MisSolicitudesPantalla.vue?vue&type=template&id=459dac1c&"
import script from "./MisSolicitudesPantalla.vue?vue&type=script&lang=ts&"
export * from "./MisSolicitudesPantalla.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports